import React from'react';
import { Tooltip, ResponsiveContainer } from'recharts';

const INTENSITY_COLORS = [
'#f0fdf4','#dcfce7','#bbf7d0','#86efac',
'#4ade80','#22c55e','#16a34a','#15803d','#166534',
];

/**
 * Simple heatmap using HTML cells (Recharts doesn't natively support heatmaps).
 */
export default function HeatmapChart({ data, title, xLabels, yLabels }) {
 if (!data || data.length === 0) return null;

 const hours = xLabels || Array.from({ length: 24 }, (_, i) =>`${i}:00`);
 const days = yLabels || ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];

 // Build matrix
 const matrix = {};
 let maxVal = 0;
 for (const row of data) {
 const key =`${row.DayOfWeek}-${row.HourOfDay}`;
 const val = parseInt(row.Calls, 10) || 0;
 matrix[key] = val;
 if (val > maxVal) maxVal = val;
 }

 const getColor = (val) => {
 if (maxVal === 0) return INTENSITY_COLORS[0];
 const idx = Math.min(Math.floor((val / maxVal) * (INTENSITY_COLORS.length - 1)), INTENSITY_COLORS.length - 1);
 return INTENSITY_COLORS[idx];
 };

 return (
 <div className="chart-container">
 {title && <h3 className="text-sm font-semibold text-gray-700 mb-4">{title}</h3>}
 <div className="overflow-x-auto">
 <table className="w-full border-separate" style={{ borderSpacing:'2px' }}>
 <thead>
 <tr>
 <th className="text-xs text-gray-500 w-12" />
 {hours.map((h) => (
 <th key={h} className="text-[10px] text-gray-400 font-normal">{h.replace(':00','')}</th>
 ))}
 </tr>
 </thead>
 <tbody>
 {days.map((day, dayIdx) => (
 <tr key={day}>
 <td className="text-xs text-gray-500 font-medium pr-2">{day}</td>
 {hours.map((_, hourIdx) => {
 const val = matrix[`${dayIdx}-${hourIdx}`] || 0;
 return (
 <td
 key={hourIdx}
 className="w-6 h-6 rounded-sm cursor-default"
 style={{ backgroundColor: getColor(val) }}
 title={`${day} ${hourIdx}:00 — ${val} calls`}
 />
 );
 })}
 </tr>
 ))}
 </tbody>
 </table>
 </div>
 </div>
 );
}
